<template lang="pug">
section#giving.page-section
  .container.is-fluid.mobile-padding
    .has-text-centered
      p.is-size-3.has-text-weight-semibold.giving-title New year. <br class="mobile-break">New way to give.
      b-field.giving-buttons(grouped)
        b-field
          a.button.is-large.is-primary(href="https://app.securegive.com/foothillfamily") Give with SecureGive
        b-field
          a.button.is-large(href="https://pushpay.com/g/foothillfamily?src=hpp") Give with PushPay
      .content
        p.is-size-5 In January 2021, Foothill Family will transition from PushPay to a new online giving platform called <a href="https://app.securegive.com/foothillfamily">SecureGive</a>. PushPay will still be available through the end of the year, but we recommend moving to SecureGive now for all the latest and greatest.
        p.is-size-5 Moving to SecureGive is easy, but if you have questions about your account or run into any issues, please don&rsquo;t hesitate to call the church office at (949) 581-5070 or email us at <a href="mailto:office@foothillfamily.com">office@foothillfamily.com</a>.
  section.page-section
    .container.is-fluid.mobile-padding
      .columns
        .column.is-two-thirds
          .content
            strong.has-text-weight-semibold Will I have to create an account to use SecureGive?
            p Yes, but thankfully the process only takes a few seconds. From your SecureGive account, you will be able to see a record of your transactions and make donations with a few taps. If you run into issues creating an account, we&rsquo;re here to help.
            strong.has-text-weight-semibold I had a recurring donation setup on PushPay. Will it copy over to SecureGive?
            p No. The two systems are entirely separate.
            strong.has-text-weight-semibold I had a recurring donation setup on PushPay. Do I need to cancel it?
            p YES, PLEASE DO. Recurring donations on PushPay will not stop until we shut it down in January 2021. To ensure you don&rsquo;t give twice, we strongly recommend canceling the old recurring donation before creating a new one in SecureGive. If you need help or cannot access your account, please call the church office.
        .column.is-one-third
          location-card
</template>

<script>
import LocationCard from '@/components/LocationCard.vue';

export default {
  name: 'giving',
  components: {
    LocationCard,
  },
};
</script>

<style lang="scss">
#giving {
  .giving-title {
    padding-top: 2rem;
  }
  .giving-buttons {
    justify-content: center;
    padding: 2.5rem 0 0 0;
  }
}
@media (min-width: $tablet) {
  #giving {
    .mobile-break {
      display: none;
    }
  }
}
@media (max-width: $tablet) {
  #giving {
    .giving-buttons {
      flex-flow: column;
      margin-bottom: 2.5rem;
    }
  }
}
</style>
